module.exports = __webpack_public_path__ + "img/UY.6068a814.svg";